export default __webpack_public_path__ + "static/media/description-black.f2e8a1bb.svg";